angular.module('gym.access_control').directive('accessControlGroups', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/access_control/groups.html.slim'),
    scope: {
      tableParams: '=',
      reload: '&'
    },
    controller: ["$scope", "$window", function($scope, $window) {
      return $scope.confirmSetDefault = function(group) {
        var message;
        message = "Are you sure? This will change the default group for new Brivo Users";
        if ($window.confirm(message)) {
          return group.doPUT({}, 'set_default').then(function() {
            return $scope.reload();
          });
        }
      };
    }]
  };
});
